export default "__VITE_ASSET__gbX922CE__"